module.exports = __webpack_public_path__ + "static/media/cancel.0908d405.svg";